import { ReactElement, useContext, useEffect, useRef } from "react";
import { Accordion } from "react-bootstrap";
import { GlobalContext } from "./GlobalContext";

import './styles/AccordionGroup.scss';

export interface IAccordionGroupProps {
    title: string;
    children: ReactElement
    open?: boolean;
    loading?: boolean;
    onOpen?: () => void;
    className?: string;
    style?: React.CSSProperties;
}

const AccordionGroup = (props: IAccordionGroupProps) => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;

    useEffect(() => {
        (async () => {

        })();
    }, []);

    return (
        <Accordion
            className={props.className}
            style={{ border: "1px solid #0d6efd", borderRadius: "0.375rem", ...(props.style || {}) }}
            defaultActiveKey={(props.open ? 1 : 0).toString()} >
            <Accordion.Item eventKey="1">
                <Accordion.Header><strong>{props.title}</strong></Accordion.Header>
                <Accordion.Body
                    onEntering={() => {
                        if (props.onOpen) {
                            props.onOpen();
                        }
                    }}>
                    {props.loading && <>Loading...</>}
                    {!props.loading && props.children}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default AccordionGroup;